import { render } from "./EmptyCart.vue?vue&type=template&id=5a33eb86&scoped=true"
import script from "./EmptyCart.vue?vue&type=script&lang=js"
export * from "./EmptyCart.vue?vue&type=script&lang=js"

import "./EmptyCart.vue?vue&type=style&index=0&id=5a33eb86&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a33eb86"]])

export default __exports__